import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import useDesktopDisplay from '../../hooks/useDesktopDisplay';
import { useTranslation } from '../../i18n/LanguageProvider';

const StepperView = (props) => {
  const { isRtl } = useTranslation();
  const isDesktop = useDesktopDisplay();

  return (
    <SwipeableViews
      axis={isRtl ? 'x-reverse' : 'x'}
      index={props.activeStep}
      disabled={isDesktop || props.forceDisable}
      onChangeIndex={props.handleStepChange}
      style={{
        flex: 1,
        width: '100%'
      }}
    >
      {props.children.map((c, i) => React.cloneElement(c, { index: i }))}
    </SwipeableViews>
  );
};

StepperView.propTypes = {
  activeStep: PropTypes.number,
  forceDisable: PropTypes.bool,
  handleStepChange: PropTypes.func,
  children: PropTypes.node
};

StepperView.defaultProps = {};

export default StepperView;
